<div class="TopBarContent Pill Dark Flexbox Justify--center">
  <!-- <aside class="Flexbox Align--center">
    <img src="https://assets.benchmarkrings.com/assets/main_logo.png" alt="Benchmark Logo">
  </aside> -->
  <ul class="TabList Flexbox Align--center Gap--normal">
    @for (item of barItems(); track $index) {
      <li class="TabItem" [class.SearchItem]="item?.key === 'searchToggle'">
        <button mat-button (click)="handleAction(item)" [class.Active]="activeItem()?.title === item.title">
          <div class="ButtonContent Flexbox Align--center Justify--center" [class.ItemSearchBarItem]="item?.key === 'searchToggle'">
            @if (item.mobileIcon) {
              <mat-icon class="MobileIcon">{{ item.mobileIcon }}</mat-icon>
            }
            <span [class.HasMobileIcon]="!!item.mobileIcon" class="IconTitle">{{ item.title }}</span>
            @if (item.key === 'favorites' && bookmarks().length > 0) {
              <span class="Badge">
                {{ bookmarks().length }}
              </span>
            }
          </div>
          <!-- @if(item.key === 'favorites' && bookmarks().length > 0) {
            <div class="Badge Flexbox Align--center Justify--center">{{ bookmarks().length }}</div>
          } -->
        </button>
      </li>
    }
  </ul>
  <!-- <aside></aside> -->
</div>
@if (shouldShowSearch()) {
  <div class="SearchContainer Flexbox Align--center Justify--center">
    <app-item-search class="SearchInput" [skuToShow]="skuToShow()" (closeSearch)="shouldShowSearch.set(!this.shouldShowSearch())"></app-item-search>
  </div>
}
